/**
 * 틸트시프트 항공뷰 포스트프로세싱 — 포커스 밴드 + 상하 블러, 채도 +, 비네트.
 * 프로토타입 셰이더 이식(향후 pmndrs/postprocessing로 교체 가능, M5).
 */
import * as THREE from 'three';

export class TiltShift {
  private rt: THREE.WebGLRenderTarget;
  private postScene = new THREE.Scene();
  private postCam = new THREE.OrthographicCamera(-1, 1, 1, -1, 0, 1);
  private mat: THREE.ShaderMaterial;

  constructor(private renderer: THREE.WebGLRenderer) {
    const pr = renderer.getPixelRatio();
    this.rt = new THREE.WebGLRenderTarget(window.innerWidth * pr, window.innerHeight * pr);
    this.mat = new THREE.ShaderMaterial({
      uniforms: {
        tDiffuse: { value: this.rt.texture },
        uRes: { value: new THREE.Vector2(window.innerWidth, window.innerHeight) },
      },
      vertexShader: `varying vec2 vUv; void main(){vUv=uv; gl_Position=vec4(position,1.);}`,
      fragmentShader: `
        uniform sampler2D tDiffuse; uniform vec2 uRes; varying vec2 vUv;
        void main(){
          float blur=smoothstep(0.14,0.44,abs(vUv.y-0.52));
          vec2 px=blur*5.0/uRes;
          vec3 c=texture2D(tDiffuse,vUv).rgb*0.24;
          c+=texture2D(tDiffuse,vUv+vec2( px.x, px.y*0.6)).rgb*0.12;
          c+=texture2D(tDiffuse,vUv+vec2(-px.x, px.y*0.6)).rgb*0.12;
          c+=texture2D(tDiffuse,vUv+vec2( px.x,-px.y*0.6)).rgb*0.12;
          c+=texture2D(tDiffuse,vUv+vec2(-px.x,-px.y*0.6)).rgb*0.12;
          c+=texture2D(tDiffuse,vUv+vec2(0., px.y)).rgb*0.07;
          c+=texture2D(tDiffuse,vUv+vec2(0.,-px.y)).rgb*0.07;
          c+=texture2D(tDiffuse,vUv+vec2( px.x*1.6,0.)).rgb*0.07;
          c+=texture2D(tDiffuse,vUv+vec2(-px.x*1.6,0.)).rgb*0.07;
          float lum=dot(c,vec3(.299,.587,.114));
          c=mix(vec3(lum),c,1.22);
          vec2 q=vUv-0.5; c*=1.0-0.38*dot(q,q)*2.2;
          gl_FragColor=vec4(c,1.);
        }`,
    });
    this.postScene.add(new THREE.Mesh(new THREE.PlaneGeometry(2, 2), this.mat));
  }

  setSize(): void {
    const pr = this.renderer.getPixelRatio();
    this.rt.setSize(window.innerWidth * pr, window.innerHeight * pr);
    this.mat.uniforms.uRes!.value.set(window.innerWidth, window.innerHeight);
  }

  render(scene: THREE.Scene, camera: THREE.Camera): void {
    this.renderer.setRenderTarget(this.rt);
    this.renderer.render(scene, camera);
    this.renderer.setRenderTarget(null);
    this.renderer.render(this.postScene, this.postCam);
  }
}
